/**
 * Formato esperado pelo backend para associar items a uma atividade
 */
export interface ActivityLv4ItemAttribute {
  lv4_item_id: string
}

/**
 * Transforma os activity_lv4_items retornados pela IA
 * no formato esperado pelo backend
 */
export function formatActivityItemsForBackend(
  aiItems: any[] | undefined | null
): ActivityLv4ItemAttribute[] {
  if (!aiItems || !Array.isArray(aiItems) || aiItems.length === 0) {
    return []
  }

  return aiItems
    .map(item => {
      // Caso 1: Item é um objeto com campo 'id'
      if (typeof item === 'object' && item !== null) {
        const itemId = item.id || item.lv4_item_id || item.lv4ItemId
        if (itemId) {
          return { lv4_item_id: itemId }
        }
      }

      // Caso 2: Item é uma string (apenas o ID)
      if (typeof item === 'string') {
        return { lv4_item_id: item }
      }

      return null
    })
    .filter((item): item is ActivityLv4ItemAttribute => item !== null)
}

/**
 * Valida se os items estão no formato correto
 */
export function validateActivityItems(
  items: ActivityLv4ItemAttribute[]
): boolean {
  if (!Array.isArray(items)) return false

  return items.every(
    item =>
      item &&
      typeof item === 'object' &&
      typeof item.lv4_item_id === 'string' &&
      item.lv4_item_id.length > 0
  )
}

